import LeftSidebar from "../Pages/Blog/LeftSidebar";
import NoSidebar from "../Pages/Blog/NoSidebar";
import RightSidebar from "../Pages/Blog/RightSidebar";
import SidebarDetails from "../Pages/Blog/SidebarDetails";
import About from "../Pages/Bonus/About";
import Elements from "../Pages/Bonus/Elements";
import FAQ from "../Pages/Bonus/FAQ";
import { Route } from "./RouteList";

export const PageRoutes = [
  { path: Route.Elements, element: <Elements /> },
  { path: Route.RightSidebar, element: <RightSidebar /> },
  { path: Route.LeftSidebar, element: <LeftSidebar /> },
  { path: Route.SidebarDetails, element: <SidebarDetails /> },
  { path: Route.NoSidebar, element: <NoSidebar /> },
  { path: Route.About, element: <About /> },
  { path: Route.Faq, element: <FAQ /> },
];
